import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { UIRouter }                                      from '@uirouter/core';
import { TranslateService }                              from '@ngx-translate/core';

import { ApiService }    from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import { CustomerPaymentActionsComponent } from './customer-payments/customer-payment.actions.component';
import { CustomerPaymentsService }         from '../../app-lite/customer-payments/customer-payments.service';

@Component({
  selector   : 'customer-payments',
  template: require('./customer-payments/customer-payments.html')
})
export class CustomerPaymentsListComponent implements OnInit {
  @Input() customer: any;
  @Input() payments: any[];

  columns: any[];
  showCustomerPayments: boolean;
  tableCacheKey: string;
  tableSettings: any;

  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService: ApiService,
    @Inject(forwardRef(() => CustomerPaymentsService)) private customerPaymentApi: CustomerPaymentsService,
    @Inject(forwardRef(() => TableService)) private tableService: TableService,
    private router: UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    this.showCustomerPayments = !!this.payments.length;
    this.tableCacheKey        = 'customerPayments';

    this.columns = [
      {
        field : 'customer_payment_number',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.PAYMENT_NUMBER')
        }
      },
      {
        field : 'reference',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        field : 'post_date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-right',
        field  : 'applied_amount',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('JS_SPACE.COLUMNS.APPLIED_AMOUNT')
        },
        pipe: 'globalCurrency',
      },
      {
        classes: 'text-right',
        field  : 'amount',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onViewMethodsClick: (payment) => this.viewPaymentMethods(payment),
              onEditClick       : (payment) => this.router.stateService.go('app.customer-payment', {
                customer_id: payment.customer_id,
                id         : payment.id
              })
            }
          },
          enabled: !this.customer.archived,
          factory: CustomerPaymentActionsComponent,
        },
        sortable: false
      }
    ];

    this.tableSettings = {
      cache: {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: this.columns,
      empty  : {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_PAYMENTS_FOUND')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 5,
        pageSizes : [ 5, 10, 25, 50 ],
        queryCount: () => this.apiService.get('/customers/payment_count/' + this.customer.id)
      },
      rows: {
        highlight: {
          enabled: true
        }
      },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'asc',
        field    : 'post_date'
      }),
    };
  }

  getPayments ( params ): Promise<any> {
    return this.apiService.get('/customers/payment_list', [
      this.customer.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then((payments) => {
      this.payments = payments;

      return payments;
    });
  }

  onRowDoubleClick ( event: any ): void {
    if ( !this.customer.archived ) {
      this.router.stateService.go('app.customer-payment', {
        customer_id: this.customer.id,
        id         : event.row.id
      });
    }
  }

  viewPaymentMethods ( row: any ): void {
    this.customerPaymentApi.getPayment(row.id)
    .then((payment) => this.customerPaymentApi.viewPaymentMethods(payment));
  }
}
